export default {
  items: [
    {
      name: 'Dashboard',
      url: '/corporate/visitorTag/dashboard',
      icon: 'icon-speedometer',
    },
    {
      name: 'Manage Receptionists',
      url: '/corporate/visitorTag/receptions',
      icon: 'icon-people',
    },
    {
      name: 'Review Meetings',
      url: '/corporate/visitorTag/history',
      icon: 'icon-people',
    },
    {
      name: 'Review Visitors',
      icon: 'icon-star',
      children: [
        {
          name: 'Check IN Visitors',
          url: '/corporate/visitorTag/checkIn',
          icon: 'icon-star',
        },
        {
          name: 'Check Out Visitors',
          url: '/corporate/visitorTag/checkOut',
          icon: 'icon-star',
        },
        {
          name: 'OverDue Visitors',
          url: '/corporate/visitorTag/overDue',
          icon: 'icon-star',
        },
        {
          name: 'Total Visitors in Buildings',
          url: '/corporate/visitorTag/totalVisitors',
          icon: 'icon-star',
        },
        // {
        //   name: 'Visiting History',
        //   url: '/corporate/visitorTag/history',
        //   icon: 'icon-star',
        // },
      ]
    },
    {
      name: 'Manage Wifi Packages',
      url: '/corporate/visitorTag/wifiPackages',
      icon: 'icon-people',
    }, {
      name: 'Manage Cards',
      url: '/corporate/visitorTag/card',
      icon: 'icon-people',
    },
    {
      title: true,
      name: 'iVCA', //Camera Onboarding
      wrapper: {
        element: '',        // required valid HTML5 element tag
        attributes: {}        // optional valid JS object with JS API naming ex: { className: "my-class", style: { fontFamily: "Verdana" }, id: "my-id"}
      },
      class: 'cam-onb-corp-nav align-center_'
    },
    {
      name: 'Manage Camera',
      url: '/corporate/ivca/camera-onboard',
      icon: 'icon-note',
      children: [
        {
          name: 'Create Camera',
          url: '/corporate/ivca/camera-onboard/create',
          icon: 'icon-note',
        },
        {
          name: 'View All Cameras',
          url: '/corporate/ivca/camera-onboard/view',
          icon: 'icon-chart',
        }
      ],
    },
    {
      title: true,
      name: 'REPORTS',
      wrapper: {
        element: '',
        attributes: {}
      },
      class: 'cam-onb-corp-nav align-center_'
    },
    {
      name: 'Reports',
      url: '/corporate/visitorTag/report',
      icon: 'icon-note',
      children: [
        {
          name: 'QR Check-in',
          url: '/corporate/visitortags/qr-check-in',
          icon: 'icon-chart',
        },
        {
          name: 'View Visitors',
          url: '/corporate/visitorTag/view_visitors',
          icon: 'icon-chart',
        },
        {
          name: 'View Meetings',
          url: '/corporate/visitorTag/report_meeting',
          icon: 'icon-chart',
        },{
          name: 'View Summary Report',
          icon: 'icon-people',
          url: '/corporate/report/summaryreport',
        },{
          name: 'Success/Failed Visitor Report',
          icon: 'icon-people',
          url: '/corporate/report/successfailedvisitor',
        },{
          name: 'Widgets For Visitors Report',
          icon: 'icon-people',
          url: '/corporate/report/widgetsvisitors',
        },{
          name: 'Summary report of receptionists',
          icon: 'icon-people',
          url: '/corporate/report/receptionistssummaryreport',
        }
      ],
    },
  ],
};
